import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {makeAutoObservable, observable} from "mobx";
import {RequestState} from "data/enums";
import {Bindings} from "data/constants/bindings";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import type {IUserStore} from "data/stores/user/user.store";
import type {IPlayerPoolStore} from "data/stores/player_pool/player_pool.store";
import type {IPlayer, IPlayersStore} from "data/stores/players/players.store";
import type {ITeamStore} from "data/stores/team/team.store";

interface IControllerProps {
	playerId: number;
}

export interface IPlayerSlotController extends ViewController<IControllerProps> {
	get i18n(): ILocalizationStore;
	get player(): IPlayer | undefined;

	onRemovePlayer: () => void;
}

@injectable()
export class PlayerSlotController implements IPlayerSlotController {
	@observable _requestState: RequestState = RequestState.IDLE;
	@observable private _playerId!: number;

	constructor(
		@inject(Bindings.UserStore) private _userStore: IUserStore,
		@inject(Bindings.LocalizationStore) private _i18nStore: ILocalizationStore,
		@inject(Bindings.PlayerPoolStore) private _poolStore: IPlayerPoolStore,
		@inject(Bindings.PlayersStore) private _playerStore: IPlayersStore,
		@inject(Bindings.TeamStore) private _teamStore: ITeamStore
	) {
		makeAutoObservable(this);
	}

	get i18n() {
		return this._i18nStore;
	}

	get player() {
		return this._playerStore.getPlayerById(this._playerId);
	}

	onRemovePlayer = () => {
		this._teamStore.removePlayer(this._playerId);
	};

	dispose() {
		return;
	}

	init({playerId}: IControllerProps) {
		this._playerId = playerId;
	}
}
